"use strict";
import { __require as a } from "./index.es401.js";
var i, e;
function s() {
  if (e) return i;
  e = 1;
  var n = /* @__PURE__ */ a();
  return i = function(r) {
    return n(r) || r === 0 ? r : r < 0 ? -1 : 1;
  }, i;
}
export {
  s as __require
};
//# sourceMappingURL=index.es316.js.map
